import React, { Component } from "react";
import DashboardDataTable from "../home/DashboardDataTable";
import FilterContainer from "../home/FilterContainer";

class BySource extends Component {
  /**
   * Intiliaze Dashboard for first render.
   */
  InitialiseDashboardData = () => {
    this.props.setAlertNull();
    const widget = { ...this.props.widgets };
    widget["data"] = null;
    this.props.updateState(this.props.widgetName, widget);
    this.props.getWidgetsData({
      widgetName: this.props.widgetName,
      widget: widget
    });
  };

  componentDidMount() {
    this.InitialiseDashboardData();
  }

  ChangeDashboardData = () => {
    const widget = { ...this.props.widgets };
    widget["data"] = null;
    this.props.updateState(this.props.widgetName, widget);
    this.props.getWidgetsData({
      widgetName: this.props.widgetName,
      widget: widget
    });
  };

  render() {
    return (
      <div className="right-wrpr acc-compr src-compr">
        <FilterContainer
          {...this.props.filters}
          {...this.props.widgets}
          updateState={(name, component) =>
            this.props.updateState(name, component)
          }
          ChangeDashboardData={this.ChangeDashboardData}
        />
        <DashboardDataTable
          {...this.props.widgets}
          defaultSorted={"stats_date"}
          desc={true}
        />
      </div>
    );
  }
}

export default BySource;
